import { render, staticRenderFns } from "./InventoryExpenseForm.vue?vue&type=template&id=4d5b18a4&"
import script from "./InventoryExpenseForm.vue?vue&type=script&lang=js&"
export * from "./InventoryExpenseForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryExpenseForm.vue?vue&type=style&index=0&id=4d5b18a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports